import { ID } from '../constants';
const shouldSkipSingleQuery = (loading, getAction, queryProps) => loading || !getAction || queryProps === ID;
export default shouldSkipSingleQuery;
//# sourceMappingURL=should-skip-single-query.js.map